import service from '@/api';

export default function HOME_API() {
    const getTodayLesson = async (params, callback) => {
      // const { data } = await service.get(`/api/home/today`, { params })
      // 임시코드

      let Temp = {
        lesson : "49",
        literature : [
          {
            type: "현대시",
            content: "달콤하고 기분 좋은 꿈"
          }, 
          {
            type: "현대소설",
            content: "미와 숭고를 구분한 버크"
          }
        ],
        nonliterature : [
          {
            type: "현대시",
            content: "옛집 정승초당을 둘러보고 쓰다"
          },
          {
            type: "현대소설",
            content: "미와 숭고를 구분한 버크"
          }
        ]
      }

      if (Temp) return callback(Temp);
      return null;
    }

    const getUserType = async (params, callback) => {
      // const { data } = await service.get('/api/home/usertype', { params })

      let Temp = {
        name: "김대교", 
        type: ['로봇같은', '논리주의자', '비문학형'],
        tag: ['정치사회', '경제문화', '과학']
      }

      if (Temp) return callback(Temp);
      return null;
    }

    return {
      getTodayLesson,
      getUserType
    }
};
